import React, { ComponentProps, PropsWithChildren } from 'react';

import { Button } from '@zapier/design-system';

type Props = ComponentProps<typeof Button> & {
  /** Flag to render the Spinner icon */
  isWorking: boolean;
};

const AsyncButton = ({
  children,
  isWorking,
  ...buttonProps
}: PropsWithChildren<Props>) => {
  return (
    <Button {...buttonProps} isPending={isWorking}>
      {children}
    </Button>
  );
};

export default AsyncButton;
